module.exports = __webpack_public_path__ + "img/logo.9a30f084.png";